import React from 'react';
import { theme } from 'components';
import { StyledBanner, StyledAffix, useTopElementHeight } from './utils';

const NotAvailableBanner: React.FC = () => {
  const offsetTop = useTopElementHeight();

  return (
    <StyledAffix offsetTop={offsetTop}>
      <StyledBanner $color={theme.getColor('red3')}>
        This page is not available for the assumed user on the MLS Agent Plan.
      </StyledBanner>
    </StyledAffix>
  );
};

export default NotAvailableBanner;
